import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCommonDepList, getCommonDepStaff } from 'api/common';
import { getAvatar } from '@/util/util';
import variables from '@/assets/styles/variables.scss';
import { utilCookies } from '@/util/cookies';
export default {
  name: 'oranization',
  props: {
    api: {
      type: Object,
      default: function _default() {
        return {
          list: getCommonDepList,
          // 获取列表
          search: getCommonDepStaff // 搜索列表
        };
      }
    },

    visible: {
      type: Boolean,
      // 弹窗控制
      default: false
    },
    defaultDepatment: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    defaultEmployess: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    params: {
      type: Object,
      default: function _default() {
        return {
          // is_leave: 1 过滤离职人员
          // settlement_type: 1 结算方式为月结
          // data_privilege: 是否限制数据权限 1 限制 0或者不传就是不限制
          // default_select: 默认选中的部门或者人员，1 默认选中部门负责人所在的部门
        };
      }
    },
    control: {
      type: Object,
      default: function _default() {
        return {
          all: 1,
          // 是否展示全选
          depShow: 1,
          // 1部门可选 2 部门不展示复选框 3部门禁用复选框
          staffShow: 1,
          // 1人员可选 2人员不展示复选框 3人员禁用复选框
          staffMax: null,
          // 限制选择人员最大个数 只选择人员的时候可使用
          isRegister: null,
          // 是否添加激活限制
          default_select_dept: false,
          // true默认选中负责人，且不能删除，false不默认选中
          visible: false // 自己控制弹窗展示关闭 false 当前组建关闭，true父组件控制关闭
        };
      }
    }
  },
  data: function data() {
    var str = utilCookies.getLanguage() || 'en';
    return {
      variables: variables,
      selectAll: false,
      // 是否全选
      loading: false,
      // 数据框loading
      breadcrumb: [],
      // 组织架构面包屑
      currentSelectDepID: 0,
      // 当前选中部门ID
      dept_list: [],
      // 部门列表
      staff_list: [],
      // 员工列表
      // 选中项
      selected: {
        dept_list: [],
        staff_list: []
      },
      searchKeyword: '',
      // 搜索内容
      setTimeOutDepList: null,
      lang: str,
      default_select_deptId: [],
      default_select_dept: [] // 接口参数有default_select时 且 control.default_select_dept为true
    };
  },
  created: function created() {
    this.init();
  },
  computed: {
    // 列表项
    allList: function allList() {
      return [].concat(_toConsumableArray(this.dept_list), _toConsumableArray(this.staff_list));
    },
    // 已选中项
    allSelectedList: function allSelectedList() {
      return [].concat(_toConsumableArray(this.selected.dept_list), _toConsumableArray(this.selected.staff_list));
    }
  },
  watch: {
    visible: function visible(v) {
      if (v) {
        var selected = {
          dept_list: this.defaultDepatment,
          staff_list: this.defaultEmployess
        };
        this.selected = JSON.parse(JSON.stringify(selected));
      }
    },
    defaultDepatment: {
      handler: function handler(v) {
        var selected = {
          dept_list: v
        };
        this.selected.dept_list = JSON.parse(JSON.stringify(selected)).dept_list;
      },
      immediate: true,
      deep: true
    },
    defaultEmployess: {
      handler: function handler(v) {
        var selected = {
          staff_list: v
        };
        this.selected.staff_list = JSON.parse(JSON.stringify(selected)).staff_list;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    init: function init() {
      this.getCommonDepList();
    },
    // 判断全选
    handlerSelectAll: function handlerSelectAll() {
      var _this = this;
      var selected = {};
      if (this.control.depShow === 1) selected.dept_list = [];
      if (this.control.staffShow === 1) selected.staff_list = [];
      // 选中
      this.allList.forEach(function (item) {
        var _this$createKey = _this.createKey(item),
          key = _this$createKey.key;
        if (selected[key]) {
          item.isSelect = _this.selectAll;
          if (_this.selectAll) selected[key].push(item);
        }
      });
      this.selected.dept_list = selected.dept_list || [];
      this.selected.staff_list = selected.staff_list || [];
    },
    // 生成员工头像姓名
    getAvatar: getAvatar,
    // 获取部门列表
    getCommonDepList: function getCommonDepList(id) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, _res$data, dept_list, staff_list, default_select_dept, dept_ids;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.loading = true;
              _context.next = 3;
              return _this2.api.list(_objectSpread({
                department_id: id || _this2.currentSelectDepID
              }, _this2.params));
            case 3:
              res = _context.sent;
              _this2.loading = false;
              _res$data = res.data, dept_list = _res$data.dept_list, staff_list = _res$data.staff_list, default_select_dept = _res$data.default_select_dept; // 部门列表
              _this2.dept_list = _this2.makeSelect(dept_list);
              // 员工列表
              _this2.staff_list = _this2.makeSelect(staff_list);
              if (_this2.control.default_select_dept && default_select_dept.length) {
                _this2.default_select_deptId = []; // 默认部门负责人所有id
                _this2.default_select_dept = []; // 默认部门负责人所有数据
                dept_ids = []; // 已选择部门所有id
                // 获取已选择部门所有id
                _this2.selected.dept_list.forEach(function (item) {
                  dept_ids.push(item.department_id);
                });
                default_select_dept.forEach(function (item) {
                  // 获取默认部门负责人所有id
                  _this2.default_select_deptId.push(item.department_id);
                  // 判断已选择所有部门id中是否存在默认部门id，不存在则选中
                  if (!dept_ids.includes(item.department_id)) {
                    _this2.selected.dept_list.push(item);
                  }
                });
                // 获取默认部门负责人所有数据
                _this2.default_select_dept = JSON.parse(JSON.stringify(default_select_dept));
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 获取key
    createKey: function createKey(item) {
      var isDept = !item.staff_id ? 0 : 1;
      var key = isDept ? 'staff_list' : 'dept_list';
      var indexKey = isDept ? 'staff_id' : 'department_id';
      return {
        key: key,
        indexKey: indexKey
      };
    },
    // 生成isSelect字段
    makeSelect: function makeSelect(params) {
      var _this3 = this;
      if (!Array.isArray(params)) return false;
      return params.map(function (item) {
        var _this3$createKey = _this3.createKey(item),
          indexKey = _this3$createKey.indexKey;
        var isHas = _this3.allSelectedList.some(function (cu) {
          return cu[indexKey] === item[indexKey];
        });
        item.isSelect = isHas;
        return item;
      });
    },
    // 判断已选列表中是否有当前项
    isHasItem: function isHasItem(item) {
      var _this$createKey2 = this.createKey(item),
        indexKey = _this$createKey2.indexKey;
      return this.allSelectedList.some(function (current) {
        return current[indexKey] === item[indexKey];
      });
    },
    // 是否展示状态
    handlerState: function handlerState(item) {
      return item && item.state && item.state_txt;
    },
    handleCheck: function handleCheck(item, type) {
      var _this$control = this.control,
        depShow = _this$control.depShow,
        default_select_dept = _this$control.default_select_dept,
        staffShow = _this$control.staffShow;
      if (item.department_id) {
        // 部门id时，staffShow为3禁用
        if (depShow === 3 && type === 'check') return true;
        // 部门id时，default_select_dept为true且默认负责人部门中存在当前部门id禁用
        else if (default_select_dept && this.default_select_deptId.includes(item.department_id)) return true;
      } else if (item.staff_id && staffShow === 3 && type === 'check') return true; // 个人id时，staffShow为3禁用
      return false;
    },
    // 选中状态处理
    handlerSelected: function handlerSelected(item) {
      var _this4 = this;
      var _this$createKey3 = this.createKey(item),
        key = _this$createKey3.key,
        indexKey = _this$createKey3.indexKey;
      var status = item.isSelect;
      // 是否包含
      var isHas = this.isHasItem(item);
      // 状态为真且不包含
      if (status && !isHas) this.selected[key].push(item);
      // 状态为假且包含
      if (!status && isHas) {
        this.selected[key].map(function (cu, index) {
          if (cu[indexKey] === item[indexKey]) _this4.selected[key].splice(index, 1);
        });
      }
      // 限制选中人员个数
      if (key === 'staff_list' && this.control.staffMax) {
        if (this.selected[key].length > this.control.staffMax) {
          this.selected[key] = this.selected[key].splice(0, this.control.staffMax);
          this.staff_list.forEach(function (sItem) {
            if (item.staff_id === sItem.staff_id) sItem.isSelect = false;
          });
        }
      }
    },
    // 删除选中某一项
    handlerDel: function handlerDel(item) {
      var _this5 = this;
      var _this$createKey4 = this.createKey(item),
        key = _this$createKey4.key,
        indexKey = _this$createKey4.indexKey;
      // 左侧选择栏是否包含当前删除项
      var result = this.allList.filter(function (cu) {
        return cu[indexKey] === item[indexKey];
      })[0];
      // 包含取消选择
      if (result) result.isSelect = false;
      this.selected[key].map(function (cu, index) {
        if (cu[indexKey] === item[indexKey]) _this5.selected[key].splice(index, 1);
      });
    },
    // 清空全部 逻辑大概同上
    handlerClearAll: function handlerClearAll() {
      var _this6 = this;
      var default_select_dept = this.control.default_select_dept;
      this.allSelectedList.forEach(function (item) {
        var _this6$createKey = _this6.createKey(item),
          indexKey = _this6$createKey.indexKey;
        var result = _this6.allList.filter(function (cu) {
          return cu[indexKey] === item[indexKey];
        })[0];
        if (default_select_dept && item.department_id) {
          // default_select_dept为true且为部门时，在默认负责人部门中存在不取消勾选
          if (!_this6.default_select_deptId.includes(item.department_id)) {
            if (result) result.isSelect = false;
          }
        } else {
          if (result) result.isSelect = false;
        }
      });
      this.selected = {
        dept_list: [],
        staff_list: []
      };
      // default_select_dept为true且为部门时，需要将默认负责人部门选中并在右边展示不能取消
      if (default_select_dept) {
        this.selected.dept_list = this.default_select_dept;
      }
    },
    // 面包屑点击处理
    handleBreadClick: function handleBreadClick(id, index) {
      // 请求列表数据
      this.getCommonDepList(id);
      // 删除index之后的面包屑
      this.breadcrumb.splice(index);
    },
    // 展开部门子级菜单
    openChild: function openChild(params) {
      var id = params.department_id !== undefined ? params.department_id : params.staff_id;
      this.getCommonDepList(id);
      this.breadcrumb.push(params);
    },
    // 搜索
    handlerChangeSearch: function handlerChangeSearch() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this7.breadcrumb = [];
              _this7.staff_list = [];
              // 搜索框由内容时，调用搜索接口；无内容时调用部门列表
              if (!_this7.searchKeyword) {
                _context2.next = 9;
                break;
              }
              _context2.next = 5;
              return _this7.api.search(_objectSpread({
                search_name: _this7.searchKeyword
              }, _this7.params));
            case 5:
              res = _context2.sent;
              _this7.staff_list = _this7.makeSelect(res.data);
              _context2.next = 10;
              break;
            case 9:
              _this7.setTimeOutDepList = _this7.getCommonDepList();
            case 10:
              _this7.dept_list = [];
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 取消选择我
    handleCancel: function handleCancel() {
      this.$emit('update:visible', false);
    },
    // 提交
    doSubmint: function doSubmint() {
      // 总人数
      var staffCount = this.createStaffCount();
      var Ids = this.createIds();
      this.$emit('onConfirm', _objectSpread(_objectSpread({}, this.selected), {}, {
        staffCount: staffCount
      }, Ids));
      if (!this.control.visible) this.$emit('update:visible', false);
    },
    // 生成人员总数
    createStaffCount: function createStaffCount() {
      var _this$selected = this.selected,
        staff_list = _this$selected.staff_list,
        dept_list = _this$selected.dept_list;
      staff_list = Array.isArray(staff_list) ? staff_list.length : 0;
      var num = 0;
      // debugger
      if (Array.isArray(dept_list) && dept_list.length) {
        dept_list.forEach(function (item) {
          num += item.staff_count || 0;
        });
      }
      return staff_list + num;
    },
    // 生成Id
    createIds: function createIds() {
      var _this$selected2 = this.selected,
        staff_list = _this$selected2.staff_list,
        dept_list = _this$selected2.dept_list;
      return {
        staffIds: staff_list.map(function (item) {
          return item.staff_id;
        }),
        depIds: dept_list.map(function (item) {
          return item.department_id;
        })
      };
    }
  }
};